import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getWorkflowVersion } from 'FRONTEND/utils/backendApi/workflowApi';
import { getNonSerializableItem, removeNonSerializableItem, saveNonSerializableItem } from 'FRONTEND/utils/nonSerializableStorage';

const REDUCER_NAME = 'workflows';

const readWorkflow = createAsyncThunk(`${REDUCER_NAME}/readWorkflow`, async({ id, version }, { getState }) => {
  const currentStorageId = getState()[REDUCER_NAME].storageId;
  const currentWorkflow = getNonSerializableItem(currentStorageId);
  if (currentWorkflow && currentWorkflow.id === id && currentWorkflow.version === version) {
    return { storageId: currentStorageId };
  }
  const workflow = await getWorkflowVersion({ id, version });
  // Workflow may be too big for the store, so we save it in the non-serializable storage
  // We only store the storage id that allows us to retrieve it later
  removeNonSerializableItem(currentStorageId);
  const storageId = saveNonSerializableItem(workflow);
  return { storageId };
});

// We don't store the whole workflow because it's too big for the store.
// The actual workflow form is in the in-memory non-serializable storage under the storageId key.
export const initialState = {
  storageId: null,
};

const slice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    initWorkflowsState(state, action) {
      state.storageId = action.payload.storageId;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(readWorkflow.fulfilled, (state, { payload: { storageId } }) => {
      state.storageId = storageId;
    });
  },
});

export {
  readWorkflow,
};
export const {
  initWorkflowsState,
} = slice.actions;

export default slice.reducer;
